import React from 'react';
import { ChevronDown } from 'lucide-react';

const HeroSection = () => {
  const scrollToNext = () => {
    document.getElementById('our-brands')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="min-h-screen flex flex-col justify-center items-center bg-[#1B4D3E] px-6 py-32 md:px-12">
      <div className="max-w-5xl mx-auto text-center">
        <h1
          className="text-5xl md:text-7xl lg:text-8xl font-bold text-[#F5F0EB] mb-8 leading-tight"
          style={{ fontFamily: 'Space Grotesk, sans-serif' }}>We buy Super Boring eCom businesses.


        </h1>
        
        <p className="text-xl md:text-2xl text-[#E8E2DB] max-w-3xl mx-auto leading-relaxed">For ecom founders in the $200K–$2M revenue range, looking for a clean cash exit and transparent process without the trouble of dealing with unorganized retail buyers.


        </p>
      </div>

      <button
        onClick={scrollToNext}
        className="absolute bottom-12 text-[#F5F0EB] hover:opacity-70 transition-opacity animate-bounce"
        aria-label="Scroll to next section">

        <ChevronDown className="w-8 h-8" strokeWidth={2} />
      </button>
    </section>);

};

export default HeroSection;